// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProviderClaimResponsibilityCategoryType {
    CLAIMCLOSEOUT = 'CLAIM_CLOSEOUT',
    CLAIMPAID = 'CLAIM_PAID',
    FAXRECEIVED = 'FAX_RECEIVED',
    MAILRECEIVED = 'MAIL_RECEIVED',
    PHONERECEIVED = 'PHONE_RECEIVED',
    PAYMENTRECEIVED = 'PAYMENT_RECEIVED',
    HL7RECEIVED = 'HL7_RECEIVED',
    PROFESSIONALCREATED = 'PROFESSIONAL_CREATED',
    TRANSMISSIONWITHIN45DAYS = 'TRANSMISSION_WITHIN_45_DAYS',
    TRANSMISSIONBEYOND45DAYS = 'TRANSMISSION_BEYOND_45_DAYS',
    TRANSMISSIONREJECTEDORDENIED = 'TRANSMISSION_REJECTED_OR_DENIED',
    FAXFAILED = 'FAX_FAILED',
    LETTERPAYERADDRESSNOTVALID = 'LETTER_PAYER_ADDRESS_NOT_VALID',
    LETTERPAYERWITHIN45DAYS = 'LETTER_PAYER_WITHIN_45_DAYS',
    LETTERPAYERBEYOND45DAYS = 'LETTER_PAYER_BEYOND_45_DAYS',
    LETTERGUARANTORWITHIN45DAYS = 'LETTER_GUARANTOR_WITHIN_45_DAYS',
    LETTERGUARANTORBEYOND45DAYS = 'LETTER_GUARANTOR_BEYOND_45_DAYS',
    FAXPAYERNUMBERNOTVALID = 'FAX_PAYER_NUMBER_NOT_VALID',
    FAXWITHIN45DAYS = 'FAX_WITHIN_45_DAYS',
    FAXBEYOND45DAYS = 'FAX_BEYOND_45_DAYS',
    PHONEWITHIN45DAYS = 'PHONE_WITHIN_45_DAYS',
    PHONEBEYOND45DAYS = 'PHONE_BEYOND_45_DAYS',
    SUPPORTCOMMENTWITHIN7DAYS = 'SUPPORT_COMMENT_WITHIN_7_DAYS',
    SUPPORTCOMMENTBEYOND7DAYS = 'SUPPORT_COMMENT_BEYOND_7_DAYS',
    SUPPORTCOMMENT = 'SUPPORT_COMMENT',
    PROVIDERCOMMENT = 'PROVIDER_COMMENT',
    CLAIMEMPTY = 'CLAIM_EMPTY',
    CROSSOVERTRANSMISSIONWITHIN45DAYS = 'CROSSOVER_TRANSMISSION_WITHIN_45_DAYS',
    CROSSOVERTRANSMISSIONBEYOND45DAYS = 'CROSSOVER_TRANSMISSION_BEYOND_45_DAYS',
    PAYERRESPONSIBILITYTAGWITHIN45DAYS = 'PAYER_RESPONSIBILITY_TAG_WITHIN_45_DAYS',
    PAYERRESPONSIBILITYTAGBEYOND45DAYS = 'PAYER_RESPONSIBILITY_TAG_BEYOND_45_DAYS',
    GUARANTOROVERPAYMENT = 'GUARANTOR_OVERPAYMENT',
    INTERNALESCALATION = 'INTERNAL_ESCALATION',
    GUARANTORCOLLECTIONS = 'GUARANTOR_COLLECTIONS',
    PROVIDERRESPONSIBILITYTAGWITHIN45DAYS = 'PROVIDER_RESPONSIBILITY_TAG_WITHIN_45_DAYS',
    PROVIDERRESPONSIBILITYTAGBEYOND45DAYS = 'PROVIDER_RESPONSIBILITY_TAG_BEYOND_45_DAYS',
    CODINGWITHIN7DAYS = 'CODING_WITHIN_7_DAYS',
    CODINGBEYOND7DAYS = 'CODING_BEYOND_7_DAYS',
    INACTIVECHARGEMASTERITEM = 'INACTIVE_CHARGEMASTER_ITEM',
    INSTITUTIONALCREATED = 'INSTITUTIONAL_CREATED',
    JSONRECEIVED = 'JSON_RECEIVED',
    CODINGSUBMITTED = 'CODING_SUBMITTED',
    CODINGCOMPLETED = 'CODING_COMPLETED',
    CODINGERROR = 'CODING_ERROR',
    CLAIMUPDATERECEIVED = 'CLAIM_UPDATE_RECEIVED',
    EMAILFAILED = 'EMAIL_FAILED',
    EMAILPAYERNOTVALID = 'EMAIL_PAYER_NOT_VALID',
    EMAILWITHIN45DAYS = 'EMAIL_WITHIN_45_DAYS',
    EMAILBEYOND45DAYS = 'EMAIL_BEYOND_45_DAYS',
    CLAIMSTATUSRECEIVED = 'CLAIM_STATUS_RECEIVED',
    CLAIMHALT = 'CLAIM_HALT',
    UNKNOWN = 'UNKNOWN'
}

export function ProviderClaimResponsibilityCategoryTypeFromJSON(json: any): ProviderClaimResponsibilityCategoryType {
    return json as ProviderClaimResponsibilityCategoryType;
}

export function ProviderClaimResponsibilityCategoryTypeToJSON(value?: ProviderClaimResponsibilityCategoryType): any {
    return value as any;
}

